import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import { ReactComponent as Logo } from './logo-white.svg';

const useStyles = makeStyles((theme) => ({
  spacer: {
    flexGrow: 1,
  },
  bold: {
    fontWeight: 700,
  },
  image: {
    height: 100,
  },
}));

const Success = () => {
  const classes = useStyles();

  return (
    <>
      <AppBar elevation={0}>
        <Toolbar>
          <a href="https://www.daexus.io">
            <Logo />
          </a>
          <span className={classes.spacer} />
          <Button color="inherit" style={{ textTransform: 'none' }} href="/">
            Go to your Daexus profile
          </Button>
        </Toolbar>
      </AppBar>
      <Box p={6} />
      <Container component={Paper} variant="outlined" maxWidth="md">
        <Box my={2}>
          <Typography
            variant="h4"
            align="center"
            color="primary"
            className={classes.bold}
          >
            We like you too and we're grateful for your trust!
          </Typography>
          <br />
          <br />
          <br />
          <br />
          <Grid container spacing={9}>
            <Grid item sm={4}>
              <Typography
                variant="h5"
                align="center"
                color="secondary"
                className={classes.bold}
              >
                <img src="/run.png" className={classes.image} />
                <br />
                <br />
                You're all set!
                <br />
                <br />
              </Typography>
              <Typography>
                Follow the{' '}
                <a
                  href="https://daexus.helpsite.com/categories/14344-daexus-catalyst-connector-free-version-quick-start"
                  target="_blank"
                >
                  instructions
                </a>{' '}
                in our{' '}
                <a href="https://daexus.helpsite.com/" target="_blank">
                  Support Center
                </a>{' '}
                to access the Catalyst Connector and start discovering those
                revolutionary insights!
              </Typography>
            </Grid>
            <Grid item sm={4}>
              <Typography
                variant="h5"
                align="center"
                color="secondary"
                className={classes.bold}
              >
                <img src="/heart.png" className={classes.image} />
                <br />
                <br />
                Sharing is caring
                <br />
                <br />
              </Typography>
              <Typography>
                Show some love and spread the word! Follow our social accounts
                below to keep up with our activity and maybe share our posts if
                you're feeling particularly generous.
                <br />
                <br />
              </Typography>
              <Typography align="center">
                <IconButton href="https://facebook.com/Daexus" target="_blank">
                  <FacebookIcon />
                </IconButton>
                <IconButton
                  href="https://twitter.com/DaexusCatalyst"
                  target="_blank"
                >
                  <TwitterIcon />
                </IconButton>
                <IconButton
                  href="https://www.linkedin.com/company/daexus"
                  target="_blank"
                >
                  <LinkedInIcon />
                </IconButton>
              </Typography>
            </Grid>
            <Grid item sm={4}>
              <Typography
                variant="h5"
                align="center"
                color="secondary"
                className={classes.bold}
              >
                <img src="/bell.png" className={classes.image} />
                <br />
                <br />
                Don't be a stranger!
                <br />
                <br />
              </Typography>
              <Typography>
                Subscribe to our newsletter to be the first to find out all
                about our product updates, new features and blog posts sprinkled
                with how to's, ins and outs of running a business, and much
                more.
                <br />
                <br />
              </Typography>
              <Typography align="center">
                <Button
                  href="https://daexus.us17.list-manage.com/subscribe/post?u=67ba9ee2d2fa44c02f500054e&amp;id=48a64afab8"
                  color="secondary"
                  variant="contained"
                  target="_blank"
                >
                  Subscribe
                </Button>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Box my={4} />
    </>
  );
};

export default Success;
